import * as React from 'react'

function SvgSkull(props, svgRef) {
  return (
    <svg viewBox="0 0 24 28" fill="none" xmlns="http://www.w3.org/2000/svg" ref={svgRef} {...props}>
      <path d="M23.526 24.455l-7.606-3.728 7.606-3.728a.866.866 0 00.383-1.158l-.767-1.545a.855.855 0 00-1.15-.387L12 18.806l-9.993-4.897a.854.854 0 00-1.15.387L.091 15.84a.867.867 0 00.383 1.158l7.606 3.728-7.606 3.728a.866.866 0 00-.383 1.159l.767 1.545c.211.426.726.6 1.15.386L12 22.648l9.992 4.897a.855.855 0 001.15-.386l.767-1.546a.867.867 0 00-.383-1.158zM8.036 12.808l-.294 1.396c-.143.681.29 1.341.881 1.341h6.755c.59 0 1.024-.66.88-1.341l-.294-1.396c2.238-1.21 3.75-3.387 3.75-5.899C19.714 3.093 16.26 0 12 0S4.286 3.093 4.286 6.909c0 2.512 1.512 4.689 3.75 5.899zM15 6.045c.945 0 1.714.775 1.714 1.728 0 .952-.769 1.727-1.714 1.727a1.722 1.722 0 01-1.714-1.727c0-.953.768-1.728 1.714-1.728zm-6 0c.945 0 1.714.775 1.714 1.728C10.714 8.725 9.945 9.5 9 9.5a1.722 1.722 0 01-1.714-1.727c0-.953.768-1.728 1.714-1.728z" />
    </svg>
  )
}

const ForwardRef = React.forwardRef(SvgSkull)
export default ForwardRef
